import React, { useEffect, useState } from "react";

import useMediaQuery from "@vahak/core-ui/dist/hooks/useMediaQuery";

import DownloadAppQrModal, { DOWNLOAD_APP_QR_MODAL } from "./DownloadAppQrModal";

// TEMP: open store links on web instead of the QR modal. Set to false to restore QR flow.
const TEMP_DISABLE_QR_MODAL = true;

type ModalListener = (isOpen: boolean) => void;

const modalListeners = new Set<ModalListener>();

const downloadAppQrModalController = {
    open: () => modalListeners.forEach((listener) => listener(true)),
    close: () => modalListeners.forEach((listener) => listener(false)),
    subscribe: (listener: ModalListener) => {
        modalListeners.add(listener);
        return () => {
            modalListeners.delete(listener);
        };
    }
};

export const DownloadAppQrModalHost = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => downloadAppQrModalController.subscribe(setIsOpen), []);

    return <DownloadAppQrModal isOpen={isOpen} onClose={downloadAppQrModalController.close} />;
};

export interface DownloadAppActionProps extends React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
    storeUrl?: string;
    href?: string;
}

const DownloadAppAction = ({ children, storeUrl, href, onClick, className, ...rest }: DownloadAppActionProps) => {
    const isMobile = useMediaQuery({ queryType: "mobile" });

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        onClick?.(event);
        event.preventDefault();

        const url = href ?? storeUrl ?? DOWNLOAD_APP_QR_MODAL.defaultStoreUrl;

        if (TEMP_DISABLE_QR_MODAL || isMobile) {
            window.open(url, "_blank", "noopener,noreferrer");
            return;
        }

        downloadAppQrModalController.open();
    };

    if (href) {
        return (
            <a href={href} className={className} onClick={handleClick} {...rest}>
                {children}
            </a>
        );
    }

    return (
        <div className={className} onClick={handleClick} role="presentation" {...rest}>
            {children}
        </div>
    );
};

export default DownloadAppAction;
